import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { RowThumb, StockLevel } from '../ui';

const buildInventoryColumns = ({ t, openRowMenu }) => [
  {
    field: 'productName',
    headerName: t('Product'),
    flex: 2.2,
    minWidth: 200,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }}>
        <RowThumb src={params.row.productImage} name={params.row.productName} />
        <Typography variant="subtitle1" noWrap>{params.row.productName}</Typography>
      </Box>
    ),
  },
  {
    field: 'quantity',
    headerName: t('In stock'),
    flex: 0.7,
    minWidth: 90,
    align: 'right',
    headerAlign: 'right',
    renderCell: (params) => (
      <Typography variant="subtitle1">{params.value} {params.row.UOM}</Typography>
    ),
  },
  {
    field: 'level',
    headerName: t('Level'),
    flex: 1.2,
    minWidth: 160,
    sortable: false,
    renderCell: (params) => (
      <StockLevel
        quantity={params.row.quantity}
        threshold={params.row.lowStockThreshold ?? 10}
        labels={{ inStock: t('In stock'), lowStock: t('Low stock'), outOfStock: t('Out of stock') }}
        sx={{ width: '100%' }}
      />
    ),
  },
  {
    field: 'actions',
    headerName: '',
    width: 72,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <IconButton size="small" onClick={(e) => openRowMenu(e, params.row)} aria-label={t('Actions')}>
        <MoreHorizIcon />
      </IconButton>
    ),
  },
];

export default buildInventoryColumns;
